import { Routes, RouterModule } from '@angular/router';
import { ProfileScreenComponent } from './profile.component';

const profileRoutes: Routes = [
];

export const ProfileRouter = RouterModule.forChild(profileRoutes);